var $d9a3d49db610dd5c$exports = {};
$d9a3d49db610dd5c$exports = {
    "Clear search": `I\u{161}valyti ie\u{161}k\u{105}`
};


export {$d9a3d49db610dd5c$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
